import { ChatEvaluationTestSetIndex } from '@/Workspaces/ChatEvaluationTestSet/ChatEvaluationTestSetIndex'
import { createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute(
  '/workspace/$workspaceId/chatEvaluationTestSet/$chatEvaluationTestSetId/',
)({
  component: RouteComponent,
})

function RouteComponent() {
  return (
    <ChatEvaluationTestSetIndex />
  )
}
